import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { computed } from 'vue';
import { colors } from '@friss/design-system/colors';
import { abbreviatedNumber } from '@friss/utils';
export default /*#__PURE__*/ _defineComponent({
    __name: 'FrissScoreChip',
    props: {
        /**
         * Color representation of the Friss Score.
         * Can be any valid HTML color.
         */
        color: { type: String, default: undefined },
        /**
         * Value of the Friss Score.
         */
        score: { type: Number, required: true }
    },
    setup(__props) {
        const props = __props;
        const chipColor = computed(() => {
            return props.color ?? colors.marineLight;
        });
        const formattedScore = function (score) {
            return abbreviatedNumber(score, 1);
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: "tw-border-current tw-text-caption tw-box-border tw-w-[50px] tw-rounded-md tw-border-[2px] tw-border-solid tw-text-center tw-font-bold tw-text-secondary",
                style: _normalizeStyle({ 'border-color': _unref(chipColor) }),
                "data-test-id": "score-chip"
            }, _toDisplayString(formattedScore(__props.score)), 5));
        };
    }
});
